import { useEffect } from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { useAppDispatch } from 'src/store/store';
import { fetchPublicTenantConfig, clearTenantConfig } from 'src/reducers/tenantConfigSlice';
import { setStoredTenant, buildTenantPath } from 'src/utils/tenantUtils';

/**
 * Captures the tenant ref from /t/:tenantRef/* URLs,
 * stores it in localStorage, fetches tenant config, then redirects to the same path without /t/ prefix.
 *
 * Example: /t/rds-test/login → stores "rds-test" → redirects to /login
 *
 * The redirect happens ONCE, then TenantAutoRedirect won't redirect back because
 * it checks if we're coming FROM a /t/ URL.
 */
export default function TenantRouteRedirect() {
  const params = useParams();
  const dispatch = useAppDispatch();
  const tenantRef = params.tenantRef;
  const rest = params['*'] || 'login';

  useEffect(() => {
    if (tenantRef) {
      // Clear old config first
      dispatch(clearTenantConfig());

      // Store tenant in localStorage (persists across sessions and logout)
      setStoredTenant(tenantRef);

      // Immediately fetch the new tenant's public config
      dispatch(fetchPublicTenantConfig(tenantRef));
    }
  }, [tenantRef, dispatch]);

  // Redirect to inner path (without tenant prefix)
  const innerPath = '/' + rest;

  // Use Navigate component with replace to avoid adding to history
  return <Navigate to={innerPath} replace />;
}
